import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { filterUndefineds } from '@olivierpascal/helpers';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type {
  IApiGetArticleListQueryBody,
  IApiGetArticleListResponseBody,
} from '../ArticlesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseArticlesQueryValues = {
  appId: string;
  body?: IApiGetArticleListQueryBody;
};

export const articlesQueryKeyFactory: IQueryKeyFactory<
  IUseArticlesQueryValues
> = (values) =>
  values && filterUndefineds(['articles', values.appId, values.body]);

export const useArticlesQuery = (
  values?: IUseArticlesQueryValues,
  options?: UseQueryOptions<IApiGetArticleListResponseBody, ApiError>,
): UseQueryResult<IApiGetArticleListResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: articlesQueryKeyFactory(values),
    queryFn: values
      ? () => api.articles.getAll(values.appId, values.body)
      : undefined,
    retry: options?.retry ?? 1,
    retryDelay: options?.retryDelay ?? 500,
    ...options,
  });
};
